import * as React from 'react';
import { css } from 'aphrodite';

import styles from './SVGStyles';

export default class LookingSVG extends React.PureComponent {
  render() {
    return (
      <svg
        className={css(styles.width)}
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
      >
        <g id="illustration_looking" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="Group-3" transform="translate(74.000000, 41.000000)">
            <path d="M6,18 L0,18 L0,0 L6,5 L24,5 L24,18 L6,18 Z" id="Combined-Shape" fill="#FFFFFF" />
            <path
              d="M21,10 L19,10 L19,8 L21,8 L21,10 Z M16,10 L14,10 L14,8 L16,8 L16,10 Z M11,10 L9,10 L9,8 L11,8 L11,10 Z M21,15 L19,15 L19,13 L21,13 L21,15 Z M16,15 L14,15 L14,13 L16,13 L16,15 Z M11,15 L9,15 L9,13 L11,13 L11,15 Z M18,0 L24,5.0020752 L6,5.0020752 L0,0 L18,0 Z"
              id="Combined-Shape"
              className={css(styles.grey)}
            />
          </g>
          <g id="Group-2" transform="translate(2.000000, 27.000000)">
            <polygon id="Fill-12" fill="#FFFFFF" points="5 32 21 32 21 0 5 0" />
            <path
              d="M0,32 L0,3 L5,0 L5,32 L0,32 Z M8,10 L8,8 L11,8 L11,10 L8,10 Z M15,10 L15,8 L18,8 L18,10 L15,10 Z M8,5 L8,3 L11,3 L11,5 L8,5 Z M15,5 L15,3 L18,3 L18,5 L15,5 Z M8,15 L8,13 L11,13 L11,15 L8,15 Z M15,15 L15,13 L18,13 L18,15 L15,15 Z M8,20 L8,18 L11,18 L11,20 L8,20 Z M11,32 L11,27.9969482 C11,26.8923787 11.8954305,25.9969482 13,25.9969482 C14.1045695,25.9969482 15,26.8923787 15,27.9969482 L15,32 L11,32 Z M15,20 L15,18 L18,18 L18,20 L15,20 Z"
              id="Combined-Shape"
              className={css(styles.grey)}
            />
          </g>
          <g id="Group-2" transform="translate(17.000000, 16.000000)">
            <polygon
              id="Fill-29"
              className={css(styles.grey)}
              points="66.0554863 60.330029 59.2803534 67.1032256 46.6788772 54.4998132 53.4520738 47.7266165"
            />
            <path
              d="M62.8425047,70.6618948 L52.8590087,60.681881 C52.7757476,60.5986198 52.7757476,60.4650148 52.8590087,60.3817536 L59.332078,53.9086844 C59.4153391,53.8254232 59.5508805,53.8254232 59.6341416,53.9086844 L69.6157014,63.8867618 C71.4861725,65.7591693 71.4861725,68.7894874 69.6157014,70.6618948 C67.7452302,72.5323659 64.7129758,72.5323659 62.8425047,70.6618948 Z M26,43 L26,30 L49,30 L49,43 L26,43 Z"
              id="Combined-Shape"
              className={css(styles.action)}
            />
            <g id="Group" transform="translate(12.000000, 21.000000)">
              <polygon id="Fill-21-Copy-2" fill="#FFFFFF" points="0 9 7 0 14 9 14 22 0 22" />
              <path
                d="M5,16 C5,15.0350342 5.98506755,14 7.00711069,14 C8.02820574,14 8.88433278,14.934 9,16 L8.98577862,22 L5,22 L5,16 Z"
                id="Fill-22-Copy-2"
                className={css(styles.grey)}
              />
              <polygon id="Fill-26-Copy-3" fill="#FFFFFF" points="24 17 27 17 27 13 24 13" />
              <polygon id="Fill-26-Copy-4" fill="#FFFFFF" points="30 17 33 17 33 13 30 13" />
              <polygon id="Fill-28-Copy-7" fill="#FFFFFF" points="18 17 21 17 21 13 18 13" />
            </g>
            <path
              d="M31.4285714,56.8571429 C45.4723836,56.8571429 56.8571429,45.4723836 56.8571429,31.4285714 C56.8571429,17.3847592 45.4723836,6 31.4285714,6 C17.3847592,6 6,17.3847592 6,31.4285714 C6,45.4723836 17.3847592,56.8571429 31.4285714,56.8571429 Z M31.4285714,62.8571429 C14.0710507,62.8571429 0,48.7860921 0,31.4285714 C0,14.0710507 14.0710507,0 31.4285714,0 C48.7860921,0 62.8571429,14.0710507 62.8571429,31.4285714 C62.8571429,48.7860921 48.7860921,62.8571429 31.4285714,62.8571429 Z"
              id="Combined-Shape"
              className={css(styles.actionAccent)}
              fillRule="nonzero"
            />
            <polygon
              id="Fill-20-Copy-2"
              className={css(styles.actionAccent)}
              fillRule="nonzero"
              points="34 17 34 21 29 21 29 17 25 17 25 21 19 21 26 30 49 30 42 21 38 21 38 17"
            />
          </g>
        </g>
      </svg>
    );
  }
}
